import type { MarketConfig } from '../../types';

export const academyItConfig = {
  slug: 'aca-it-sustainability',
  label: 'Academy Italy Sustainability',
  country: 'IT',
  language: 'it',
  siteSection: 'ACA_IT',
  cms: 'AzureSWA',
  title: 'Masterclass per Sustainability Managers e Practitioners | TÜV Italia Akademie',
  description:
    'Percorso di formazione e certificazione per Sustainability Manager e Practitioner in conformità alla UNI/PdR 109.1:2021.',
  themeColor: '#0046ad',
  ogImage: 'https://mango-grass-0099f4103.6.azurestaticapps.net/favicon.png',
  ogImageAlt: 'TÜV Italia Akademie Masterclass Sustainability landing page preview image',
  twitterCard: 'summary_large_image',
  robots: 'noindex,nofollow',
} satisfies MarketConfig;
